import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import TimeLine from '@/components/TimeLine';
import { columns } from './column';
import Label from '@/components/Label';
import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { isEmpty } from 'lodash';
import { showMsg } from '@/utils/util';
import {
  IssueStatus,
  TicketOperation,
  IssueStatusText,
} from '@/utils/constant';
import './index.scss';
interface Props {
  vehicleName: string;
}
const fetchApi = new IssueApi();
const WorkOrderRecord = (props: Props) => {
  const { vehicleName } = props;
  const [tableData, setTableData] = useState([]);
  const [expandRows, setExpandRows] = useState<string[]>([]);
  const getDefaultExpandRows = (list: any[]) => {
    const temp: string[] = [];
    list.forEach((row: any) => {
      if (
        row.issueStatus === IssueStatus.PROCESS ||
        row.issueStatus === IssueStatus.ON_HOLD
      ) {
        temp.push(row.issueNumber);
      }
    });
    console.log(temp);
    return temp;
  };
  const getIssueList = async () => {
    try {
      const res = await fetchApi.getVehicleIssues(vehicleName);
      if (res.code === HttpStatusCode.Success) {
        if (!isEmpty(res.data?.issueList)) {
          setTableData(res.data?.issueList);

          setExpandRows(getDefaultExpandRows(res.data?.issueList));
        } else {
          setTableData([]);
        }
      } else {
        showMsg({ msg: res.message, type: 'error' });
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getIssueList();
  }, []);

  const formatColumns = () => {
    return columns.map((column: any) => {
      switch (column.dataIndex) {
        case 'issueStatus':
          return {
            ...column,
            render: (text: string) => {
              return <>{IssueStatusText.get(text)}</>;
            },
          };
        case 'eventList':
          return {
            ...column,
            render: (text: string, record: any) => {
              const set = new Set(record.eventList);
              const eventArr: string[] = [];
              set.forEach((event: any) => eventArr.push(event));
              return eventArr.map((event: any) => {
                return <Label text={event} key={event}></Label>;
              });
            },
          };
        case 'operation':
          return {
            ...column,
            render: (text: string, record: any) => {
              return (
                <>
                  <span
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                  >
                    <span style={{ color: '#0d85ff', cursor: 'pointer' }}>
                      工单明细
                    </span>
                    {expandRows.includes(record.issueNumber) ? (
                      <img
                        src={require('../../../../assets/img/views/table-expand-icon.png')}
                        style={{ width: '16px', height: '16px' }}
                      />
                    ) : (
                      <img
                        src={require('../../../../assets/img/views/table-expand-icon.png')}
                        style={{
                          rotate: '180deg',
                          width: '16px',
                          height: '16px',
                        }}
                      />
                    )}
                  </span>
                </>
              );
            },
          };
        default:
          return {
            ...column,
            render: (text: string, record: any) => {
              if (!text) {
                return <>--</>;
              } else {
                return <>{text}</>;
              }
            },
          };
      }
    });
  };

  return (
    <>
      <div className='work-order-record-wrapper'>
        <Table
          className='work-order-record-table'
          dataSource={tableData}
          columns={formatColumns()}
          pagination={false}
          rowKey={'issueNumber'}
          expandable={{
            expandedRowKeys: expandRows,
            expandedRowRender: (record: any) => {
              const list: any = [];
              if (!isEmpty(record?.issueOperationList)) {
                record.issueOperationList.forEach((item: any) => {
                  list.push({
                    ...item,
                    operationType: TicketOperation.get(item.operationType)
                      ?.name,
                  });
                });
                return (
                  <>
                    {' '}
                    <TimeLine list={list} />
                  </>
                );
              } else {
                return <>暂无数据</>;
              }
            },
            onExpand(expanded, record) {
              if (!expanded) {
                setExpandRows(
                  expandRows.filter((row: any) => row !== record.issueNumber),
                );
              } else {
                setExpandRows([...expandRows, record.issueNumber]);
              }
            },
            expandRowByClick: true,
            expandIcon: () => <></>,
          }}
        ></Table>
        <div className='work-order-sum'>共{tableData.length}条记录</div>
      </div>
    </>
  );
};
export default React.memo(WorkOrderRecord);
